import {
  GET_TARGETS_HISTORY_FULFILLED,
  SET_HISTORY_SEARCH_QUERY,
  SET_IS_SHOW_PERSONAL_FILES_MOBILE,
  SET_MEMBER_POSITIONS_FULFILLED,
} from "../mutations.type";
import { GET_MEMBER_POSITIONS, GET_TARGETS_HISTORY } from "../actions.type";
import {
  GET_MEMBER_POSITIONS_API,
  GET_MEMBER_TARGETS_HISTORY_API,
} from "@/api/membersApi";
import { parsePermissionId } from "@/common/common-function";

export const state = {
  positions: {
    data: [],
  },
  targetsHistory: {
    page: 1,
    totalPages: 1,
    targets: [],
    totalItems: 0,
    searchQuery: {},
  },
  isShowPersonalFilesMobile: false,
};

const getters = {
  positions: (state) => state.positions.data,
  targetsHistory: (state) => state.targetsHistory,
  targetsHistorySearchQuery: (state) => state.targetsHistory.searchQuery,
  isShowPersonalFilesMobile: (state) => state.isShowPersonalFilesMobile,
};

const mutations = {
  [SET_MEMBER_POSITIONS_FULFILLED](state, payload) {
    state.positions.data = payload;
  },
  [GET_TARGETS_HISTORY_FULFILLED](state, payload) {
    state.targetsHistory.targets = payload.targets;
    state.targetsHistory.totalPages = payload.totalPages;
    state.targetsHistory.page = payload.page;
    state.targetsHistory.totalItems = payload.totalItems;
  },
  [SET_HISTORY_SEARCH_QUERY](state, payload) {
    state.targetsHistory.searchQuery = payload;
  },
  [SET_IS_SHOW_PERSONAL_FILES_MOBILE](state, payload) {
    state.isShowPersonalFilesMobile = payload;
  },
};

const actions = {
  async [GET_MEMBER_POSITIONS]({ commit }) {
    try {
      const { data } = await GET_MEMBER_POSITIONS_API();
      commit(
        SET_MEMBER_POSITIONS_FULFILLED,
        data.map((item) => ({
          ...item,
          id: parsePermissionId(item.id),
        })),
      );
    } catch (e) {
      console.error(e);
    }
  },
  async [GET_TARGETS_HISTORY]({ commit }, payload) {
    try {
      const { data } = await GET_MEMBER_TARGETS_HISTORY_API(payload);
      commit(GET_TARGETS_HISTORY_FULFILLED, data);
    } catch (e) {
      console.error(e);
    }
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
